// extracted by css-extract-rspack-plugin
export default {"worspaceFolderRow":"worspaceFolderRow-VPjy46","selectFieldContainer":"selectFieldContainer-ymEgex","btnBlock":"btnBlock-Parz1A","errorMessage":"errorMessage-cujgcY"};